import { Link } from 'react-router-dom';
import type { CaseItem } from '@/mocks/cases';

interface CaseCardProps {
  item: CaseItem;
  featured?: boolean;
}

export default function CaseCard({ item, featured = false }: CaseCardProps) {
  return (
    <Link
      to={`/cases/${item.id}`}
      className={`group block relative overflow-hidden rounded-2xl cursor-pointer ${featured ? 'lg:col-span-2' : ''}`}
    >
      <div className={`w-full overflow-hidden ${featured ? 'h-[480px] md:h-[540px]' : 'h-[340px] md:h-[400px]'}`}>
        <img
          src={item.coverImg}
          alt={item.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>

      {/* Category tag */}
      <div className="absolute top-5 left-5">
        <span className="px-3 py-1 bg-[#b8956a] text-white text-xs font-medium rounded-full">
          {item.category}
        </span>
      </div>

      {/* Year badge */}
      <div className="absolute top-5 right-5">
        <span className="px-3 py-1 bg-white/15 backdrop-blur-sm text-white text-xs rounded-full border border-white/20">
          {item.year}
        </span>
      </div>

      {/* Bottom content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
        <div className="flex flex-wrap gap-3 mb-3">
          {item.highlight.slice(0, 2).map((h) => (
            <span key={h} className="text-[#d4b896] text-xs">
              # {h}
            </span>
          ))}
        </div>
        <h3
          className="text-white font-semibold mb-1 leading-[1.35] group-hover:text-[#d4b896] transition-colors"
          style={{ fontSize: featured ? '1.375rem' : '1.125rem' }}
        >
          {item.title}
        </h3>
        <p className="text-white/65 text-sm mb-4">{item.subtitle}</p>

        <div className="flex items-center gap-4 text-white/50 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-map-pin-line"></i>
            {item.location}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-aspect-ratio-line"></i>
            {item.area}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line"></i>
            {item.duration}
          </span>
        </div>

        {/* Arrow */}
        <div className="absolute bottom-6 right-6 md:bottom-7 md:right-7 w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white/60 group-hover:bg-[#b8956a] group-hover:border-[#b8956a] group-hover:text-white transition-all duration-300">
          <i className="ri-arrow-right-up-line text-sm"></i>
        </div>
      </div>
    </Link>
  );
}
